import { useCallback, useRef } from 'react'

export function useSessionStepSyncRuntime() {
  const suppressNextSessionStepSyncRef = useRef(false)
  const sessionStepSyncLockRef = useRef<number | null>(null)
  const skippedUploadDocumentsRef = useRef(false)

  const suppressNextSessionStepSync = useCallback(() => {
    suppressNextSessionStepSyncRef.current = true
  }, [])

  const setSessionStepSyncLock = useCallback((step: number | null) => {
    sessionStepSyncLockRef.current = step
  }, [])

  const setUploadDocumentsSkipped = useCallback((skipped: boolean) => {
    skippedUploadDocumentsRef.current = skipped
  }, [])

  const consumeUploadDocumentsSkipped = useCallback(() => {
    const skipped = skippedUploadDocumentsRef.current
    skippedUploadDocumentsRef.current = false
    return skipped
  }, [])

  return {
    suppressNextSessionStepSyncRef,
    sessionStepSyncLockRef,
    suppressNextSessionStepSync,
    setSessionStepSyncLock,
    setUploadDocumentsSkipped,
    consumeUploadDocumentsSkipped
  }
}
